var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.09669 11.9041C1.03055 8.83791 1.18342 5.11958 1.48455 3.34971C1.59062 2.72684 2.02715 2.21538 2.62669 2.01404L4.51989 1.37844C4.96462 1.22918 5.44415 1.46798 5.59102 1.91178L6.35015 4.20571C6.45089 4.51011 6.37069 4.84624 6.14302 5.07398L4.67742 6.67784C4.67742 6.67784 4.10649 8.30644 5.90042 10.1004C7.69435 11.8944 9.32302 11.3234 9.32302 11.3234L10.9269 9.85778C11.1546 9.63004 11.4908 9.54984 11.7952 9.65064L14.0891 10.4097C14.533 10.5566 14.7717 11.0361 14.6224 11.4809L13.9868 13.3741C13.7856 13.9736 13.274 14.4102 12.6512 14.5162C10.8813 14.8174 7.16289 14.9703 4.09669 11.9041Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.d0fadf6251df7e241189463bbe817e13.svg";
export { ForwardRef as ReactComponent };